/* eslint-disable */
export const settings = {
    APP_NAME: 'Ambee',
    API_SERVER: 'https://automl-api.getambee.com/'
    // API_SERVER: 'http://localhost:3001/'
  }
  